import { PlusIcon, PlusInCircleIcon } from '@shared/assets/icons';
import { getRouteEventCreate } from '@shared/constants/router';
import { colors } from '@shared/tokens/colors.stylex';
import { useNavigate } from 'react-router-dom';
import { Button } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface AddEventButtonProps {
  isSminexClubGroup?: boolean;
}

export const AddEventButton = ({ isSminexClubGroup }: AddEventButtonProps) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(getRouteEventCreate());
  };

  return (
    <Button
      onClick={handleNavigate}
      settings={{ width: '109px' }}
      variant={isSminexClubGroup ? 'primary' : 'accent'}
      size="small"
    >
      <div {...stylex.props(styles.childBlock)}>
        {isSminexClubGroup ? <PlusIcon color={colors.inverseIcon} /> : <PlusInCircleIcon />}

        <p {...stylex.props(styles.text)}>Создать</p>
      </div>
    </Button>
  );
};
